import { EmailTemplateId } from 'modules/email/types/email-template-interface'
import { MailingId } from 'modules/mailing/types/mailing-interface'

export const getEmailEditorUrl = (mailingId: MailingId) =>
  `${window.location.origin}/dashboard/mailing/${mailingId}/edit`

export const getEmailTemplateEditorUrl = (emailId: EmailTemplateId) =>
  `${window.location.origin}/dashboard/email-template/${emailId}/edit`
